import styled from "@emotion/styled";

export const Text = styled.p`
  font-family: Roboto, sans-serif;
  margin: 0;
  padding: 0;
`;
